<template>
  <div>
    <vue-good-table mode="remote" @on-page-change="onPageChange" @on-sort-change="onSortChange"
      @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange" :totalRows="table.total_records"
      :isLoading.sync="table.isLoading" :pagination-options="{
          enabled: true,
          dropdownAllowAll: false,
          perPageDropdown: [10, 25, 50, 100],
        }" :columns="table.columns" :rows="table.rows">
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'expired_at'">
          {{ momentFormat(props.row.expired_at, 'DD MMMM YYYY HH:mm') }}
        </span>
        <span v-else-if="props.column.field === 'isExpired'">
          {{ props.row.isExpired ? 'Expired' : 'Aktif' }}
        </span>
        <span v-else-if="props.column.field == 'action'">
          <!-- <router-link :to="'/group/edit?id=' + props.row.id">
            <a class="btn btn-primary text-white margin5">Edit</a>
          </router-link> -->
          <a v-if="props.row.data != 'locked'" v-on:click="handleEdit(props.row)" class="btn btn-primary text-white margin5">
            Edit
          </a>

          <a v-if="props.row.data != 'locked'" v-on:click="deleteContact(props.row.id)" class="btn btn-danger text-white margin5">
            Hapus
          </a>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    data() {
      return {
        table: {
          total_records: 100,
          isLoading: true,
          columns: [{
              label: "Nama",
              field: "name",
              filterOptions: {
                enabled: true,
              },
              sortable: false,
              // width: "50%",
            },
            {
              label: "Expired At",
              field: "expired_at",
              filterOptions: {
                enabled: false,
              },
              sortable: false,
              // width: "30%",
            },
            {
              label: "Expired",
              field: "isExpired",
              filterOptions: {
                enabled: false,
              },
              sortable: false,
              // width: "30%",
            },
            {
              label: "Email",
              field: "email",
              filterOptions: {
                enabled: false,
              },
              sortable: false,
              // width: "30%",
            },
            {
              label: "Max. Device",
              field: "max_device",
              filterOptions: {
                enabled: false,
              },
              sortable: false,
              // width: "30%",
            },
            {
              label: "Max. CS",
              field: "max_cs",
              filterOptions: {
                enabled: false,
              },
              sortable: false,
              // width: "30%",
            },
            {
              label: "Action",
              field: "action",
              sortable: false,
              width: "20%",
            },
          ],
          rows: [],
          serverParams: {
            columnFilters: {},
            sort: [{
              field: "",
              type: "",
            }, ],
            page: 1,
            limit: 10,
          },
        },
      };
    },
    mounted() {
      this.fn = () => {
        this.loadItems();
      }
      this.$root.$on("refresh_table", this.fn);
      this.loadItems();
    },
    beforeDestroy() {
      this.$root.$off("refresh_table", this.fn);
    },
    methods: {
      async deleteContact(id) {
        const ok = await this.$confirm({
          title: 'Hapus Agency',
          message: 'Yakin ingin menghapus agency ini?',
          confirmText: 'Hapus',
        })
        if (!ok) return

        try {
          let response = await this.$store.dispatch("agency_user_delete", { id });
          this.loadItems();
          this.$toast.success(response.data.message);
        } catch (err) {
          this.$toast.error("Server error");
        }
      },
      updateParams(newProps) {
        this.table.serverParams = Object.assign({},
          this.table.serverParams,
          newProps
        );
      },
      onPageChange(params) {
        this.updateParams({
          page: params.currentPage
        });
        this.loadItems();
      },
      onPerPageChange(params) {
        this.updateParams({
          limit: params.currentPerPage
        });
        this.loadItems();
      },
      onSortChange(params) {
        this.updateParams({
          sort: [{
            type: params.sortType,
            field: this.table.columns[params.columnIndex].field,
          }, ],
        });
        this.loadItems();
      },
      onColumnFilter(params) {
        this.updateParams(params);
        this.loadItems();
      },
      async loadItems() {
        this.table.isLoading = true
        try {
          let response = await this.getFromServer(this.table.serverParams);
          this.table.total_records = response.data.data.total_records;
          this.table.rows = response.data.data.users.map((x) => {
            return {
              ...x,
              isExpired: moment(x.expired_at).isBefore(moment())
            }
          });
        } catch (err) {
          this.$toast.error("Too many request");
        }
        this.table.isLoading = false
      },
      async getFromServer(param) {
        return await this.$store.dispatch("agency_user_list", param);
      },
      momentFormat(date, format = "YYYY-MM-DD HH:mm:ss") {
        return moment.utc(date).local().format(format)
      },
      handleEdit(payload) {
        this.$emit("edit", payload);
      }
    },
  };
</script>

<style scoped>
  .margin5 {
    margin: 5px;
  }
</style>